// extracted by mini-css-extract-plugin
export default {"container":"V8-z","list":"W8-z"};